import React, { useEffect } from 'react'
import logo from '../../../assets/img/logo.png'
import payment from '../../../assets/img/common/payment.png'
import applebg from '../../../assets/img/custom/applebg.png'
import androidbg from '../../../assets/img/custom/androidbg.png'
import FooterLayerLeft from '../../../assets/img/custom/FooterLayerLeft.avif'
import call from '../../../assets/img/icon/call.png'
import whatsapp from '../../../assets/img/icon/whatsapp.png'
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom'
import Cookie from '../Cookie'
import NewsletterModal from '../NewsletterModal'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux";
import Swal from 'sweetalert2'
import FooterTop from '../../Pharmacy/FooterTop'
import { connect } from "react-redux";
import { AuthContext } from '../../../context/AuthContext'
import * as branche  from "../../../actions/branche";
import * as department from "../../../actions/department";
import * as user from "../../../actions/user";
import * as actions from "../../../actions/service";
import { compose } from 'redux'
import _ from 'lodash'
import { useTranslation} from 'react-i18next';
import './style.css'
import fb from '../../../assets/img/custom/social/fb.png'
import twitter from '../../../assets/img/custom/social/twitter.png'
import yt from '../../../assets/img/custom/social/yt.png'
import linked from '../../../assets/img/custom/social/linked.png'
import insta from '../../../assets/img/custom/social/insta.png'
import iosicon from '../../../assets/img/custom/ios-icon.png'
import androidicon from '../../../assets/img/custom/android-icon.png'
import BookingModal from '../../../page/bookingModal'

const Footer = (props) => {
    let dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    let promoCenter = useSelector((state) => state.settings?.promoCenter);
    let promoStatus = useSelector((state) => state.settings?.promoStatus);
    let stopPromo = useSelector((state) => state.settings?.stopPromo);
    let cookie = useSelector((state) => state.settings?.cookie);
    let stopCookie = useSelector((state) => state.settings?.stopCookie);
    // useEffect(() => {
      
    //     props.fetchDepartments();
 
        
    //   }, []);
    useEffect(() => {
        if (promoStatus) {
            return
        } else {
            dispatch({ type: "settings/promoStatus" })
            setTimeout(function () {
                dispatch({ type: "settings/promoCenter" })
            }, 2000)
        }

        if (stopCookie) {
            return
        } else {
            setTimeout(function () {
                dispatch({ type: "settings/cookie" })
            }, 6000)
        }
    }, [dispatch, promoStatus, stopCookie]);


    const startPromoModal = () => {
        if (stopPromo) {
            dispatch({ type: "settings/promoCenter" })
            return;
        } else {
            dispatch({ type: "settings/promoCenter" })
            setTimeout(function () {
                dispatch({ type: "settings/promoCenter" })
            }, 700000)
        }

    }

    const stopPromoModal = () => {
        dispatch({ type: "settings/stopPromo" })
    }

    const cancelCookie = () => {
        dispatch({ type: "settings/cookie" })
    }

    const acceptCookie = () => {
        // Write your function there
        dispatch({ type: "settings/cookie" })
    }

    return (
        <>
            <FooterTop />
            <div className='footericons'>
            <a target='_blank' href='https://api.whatsapp.com/send?phone=971564134499&text=Hello%2C%20I%20want%20to%20know%20more%20about%20services%20offered%20by%20aecmc.com'>
            <img  src={whatsapp}/>
            </a>
            <a href="tel:+97126219996">
            <img  src={call}/>
            </a>
            
            </div>
            <footer id="footer_one">
                <div className="container-fluid px-5">
                    <div className="row">
                        <div className="col-lg-4 col-md-3 col-sm-12 col-12">
                            <img className='footerLeft ml-3' src={FooterLayerLeft} />
               
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-12 col-12 mt-5 text-center pr-5 mb-3">
                        <h2 className='text-white sofia mb-3'>{t('about')}</h2>
                        <p className='text-white mb-3'>{t('aboutfooter')}</p>
                        {/* <button className='btn btn-warning btn-sm w-75'>Schedule your visit now</button> */}
                        <BookingModal type="generic" title={t('schedulevisit')}/>

                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-12 col-12 mt-5 ">
                            <div className='row'>
                            <div className='col-xl-12 col-12'>
                         
                            <ul className="right_list_fix mb-4">
                                           

                                           <li className='d-none d-sm-none d-md-block mx-2'>
                                           <h5 className='text-white'>{t('stayconnected')}</h5>
                                           </li>

                                           <li className='d-none d-sm-none d-md-block mx-1'>
                                            <a href="https://www.facebook.com/adamandevecosmeticmedicalcenter/" target='_blank'>
                                            <img className='social-icon-circle' src={fb}/>
                                            </a>

                                            <a href="http://www.twitter.com/" target='_blank' className='mx-1'>
                                            <img className='social-icon-circle' src={twitter}/>
                                            </a>
                                            {/* <a href="https://www.linkedin.com/" target='_blank' className='mx-1'>
                                            <img className='social-icon-circle' src={linked}/>
                                            </a> */}
                                            <a href="https://www.instagram.com/adamandeve_aecmc/" target='_blank' className='mx-1'>
                                            <img className='social-icon-circle' src={insta}/>
                                            </a>
                                            <a href="https://www.youtube.com/channel/UCjkpOCn2aIhUb6HS0msenkw" target='_blank' className='mx-1'>
                                            <img className='social-icon-circle' src={yt}/>
                                            </a>

                                        </li>

                                           {/* {props.branches.length >0 && <li><i className="fa fa-medkit"></i> 

                                            <select className="medical-center-input" onChange={handleBranchChange} value={currentBranch} >
                                            {props.branches.map((data, index) => (<option key={index} value={data.id}>{data.name}</option>))}
                                            </select>
                                            
                                            </li>}

                                            <li><i className="fa fa-globe"></i>  
                                            <select className="lang-center-input" onChange={changeLanguage} value={currentLang}>
                                            <option value="en">{t('english')}</option>
                                            <option value="ar">{t('arabic')}</option>
                                          
                                            </select></li> */}

                                        

                                           {/* {!user && <li><Link to="/login"><i className="fa fa-user"></i> {t('login')}</Link></li>}
                                           {!user && <li><Link to="/register"><i className="fa fa-lock"></i> {t('signup')}</Link></li>}

                                           {user && <li className="after_login"><img src={avater} alt="avater" /> {user.firstName+' '+user.lastName} <i className="fa fa-angle-down"></i>
                                                <ul className="custom_dropdown">
                                                    <li><Link to="/my-account"><i className="fa fa-tachometer"></i> Dashboard</Link></li>
                                                    <li><Link to="/my-account/customer-order"><i className="fa fa-cubes"></i> My Orders</Link></li>
                                                    <li><Link to="#!" onClick={() => { logout() }} ><i className="fa fa-sign-out"></i> Logout</Link></li>
                                                </ul>
                                            </li>} */}
                                        </ul>
                                </div>
                                <div className='col-xl-6 col-6'>
                                <div className="footer_one_widget">
                                <h3 >{t('quicklinks')}</h3>
                                <ul>
                                    <li><Link to="/about" >{t('aboutus')}</Link></li>
                                    <li><Link to="/privacy-policy" >{t('privacypolicy')}</Link></li>
                                    {/* <li><Link to="/faqs" >{t('faqs')}</Link></li> */}
                                    <li><Link to="/contacts" >{t('contactus')}</Link></li>
                                </ul>
                            </div>
                                </div>
                                <div className='col-xl-6 col-6'>
                                <div className="footer_one_widget">
                                <h3 >{t('treatments')}</h3>
                                <ul>
                                {_.sampleSize(props.servicesHeader, 6).map((data, index) => (<li key={index}>
                                    <Link to={{
                                                                            pathname: `/treatments/${(data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                                                service: data
                                                                            }
                                                                        }} >
                                                                           {data.title[i18n.language]}
                                                                        </Link>
                                </li>))}
                                </ul>
                            </div>
                                </div>
                                <div className='col-xl-12 col-12 mt-4'>
                                <small className='text-white fssmall'>{t('allrights')}</small>
                                </div>
                            </div>
                            {/* <div className="footer_one_widget">
                                <h3 >{t('departments')}</h3>
                                <ul>
                                 
                                    {_.sampleSize(props.departments, 6).map((data, index) => (<li key={index}>
                                        <Link to={{pathname: `/department-details/${data.id}`, state: {
                            department: data
                          }}} >{data.title[i18n.language]}</Link>
                                    </li>))}
                                </ul>
                            </div> */}
                        </div>
                        {/* <div className="col-lg-3 col-md-3 col-sm-12 col-12">
                            <div className="footer_one_widget text-center">
                            <div className='mb-2'>
                            <a href="https://apps.apple.com/us/app/adam-eve/id1582429670" target='_blank' className='mb-4'>
                        <img src={applebg} style={{height: '55px'}}/>
                        </a>
                            </div>
                                
                    
                        <a href="https://play.google.com/store/apps/details?id=com.adam.eve" target='_blank'>
                        <img src={androidbg} style={{height: '55px'}}/>
                        </a>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                            {FooterData.slice(0, 1).map((data, index) => (
                                <div className="footer_one_widget" key={index}>
                                    <h3>{data.title}</h3>
                                    <ul>
                                        {data.links.map((link, index) => (
                                            <li key={index}><Link to={link.link}>{link.linkTitle}</Link></li>
                                        ))}
                                    </ul>
                                </div>
                            ))}

                        </div>
                        
                        <div className="col-lg-2 col-md-6 col-sm-12 col-12">
                            {FooterData.slice(1, 2).map((data, index) => (
                                <div className="footer_one_widget" key={index}>
                                    <h3>{data.title}</h3>
                                    <ul>
                                        {data.links.map((link, index) => (
                                            <li key={index}><Link to={link.link}>{link.linkTitle}</Link></li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                        <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                            <div className="footer_one_widget">
                                <h3>NEWSLETTER</h3>
                                <div id="mc_embed_signup" className="subscribe-form">
                                    <form onSubmit={(e) => { e.preventDefault(); Swal.fire('Success', 'Thank you for your Subscribtion', 'success'); document.querySelector("input[type='email']").value = "" }}>
                                        <div className="mc-form">
                                            <input className="form-control" type="email" placeholder="Your Mail" name="EMAIL" defaultValue="" required />
                                            <div className="clear">
                                                <button className="theme-btn-one btn_md" type="submit" name="subscribe" defaultValue=""> Send Mail</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* <div className="go-top active" onClick={() => { window.scrollTo(0, 0) }}>
                    <i className="fa fa-chevron-up"></i>
                    <i className="fa fa-arrow-up"></i>
                </div> */}
            </footer>

            {/* <section id="copyright_one">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="copyright_right">
                                <h6>{t('allrights')}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {
                cookie ? <Cookie accept={acceptCookie} cancel={cancelCookie} /> : null
            }
            <NewsletterModal show={promoCenter} stop={stopPromoModal} start={startPromoModal} />
        </>
    )
}


const mapStateToProps = state => ({
    branches: state?.branche?.branches,
    meta: state?.branche?.metaBranche,
    departments: state?.department?.departments,
    metaDepartment: state?.department?.metaDepartment,
    cart: state.user.cart,
    cartArray: state.user.cartArrays,
    servicesHeader: state?.service?.servicesHeader,
    meta: state?.service?.metaService,
})

const mapActionToProps = {
 
    fetchBranches : branche.fetchAll,
    fetchDepartments : department.fetchAll,
    updateUserCart: user.updateCart,
   //fetchServices: actions.getFilteredAllServices,
    fetchFeaturedServices: actions.getFeatured,
    fetchRandomPackages: actions.fetchRandomPackages,
}

//export default withRouter (connect(mapStateToProps, mapActionToProps)(Header));
export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps)
  )(Footer);